<div class="container mt-4">
  <h3 class="mt-4 text-center m-3 boldtext" >La transacción ya fue procesada</h3>
  <p class="text-center">Estimado usuario, esta transacción ya ha sido procesada. Verifica el estado de la operación anterior antes de intentarlo nuevamente.</p>
</div>
